module.exports = __webpack_public_path__ + "static/img/areaA-35.0a0d17a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/areaA-35.png
// module id = 1072
// module chunks = 1